function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "url(#pattern0)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
  id: "pattern0",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#image0_5267_30974",
  transform: "scale(0.0104167)"
})), /*#__PURE__*/React.createElement("image", {
  id: "image0_5267_30974",
  width: 96,
  height: 96,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAADw0lEQVR4nO2dzUuUURSHn7JGrUmCiIw2JYyLxrRw0aaCdFd/QO1a1L6/oRZFYmGJgpDbiPYFfRltahNkZLTLUGrRqhwN/OhjcWdIzXHm/bj33PvOeeCsFM85v9/7vs79egcURVEURVEURVEURVGURmGLdAERaAPOAn1AD3AQ2F3+2XfgMzAJTAAPgZJAjZmkExgHFoA/dcYCcBcoCNSbGVqBQWCZ+oVfH0vAANDiuPbgKQDviS/8+ngN7HfaQcAcA76RnviVmAW6HfYRJAXsiL/ahHZn3QRGC+ZTjC3xK/EG8/9FWccg9sWvxBVHPQVDJ8k+7USNEvooWsM47sSvxKiTzgKgjWiDrLRiHtjloL9N2SpdAGZ6YYdA3p3AGYG8a/DBgL4GzQ34YUCPYG7xgZkPBhwSzN0hmBvwYzp6EcgJ5hadqPPhDmhofDBgTjD3D8HcgB8GTAvm/iSYG/DDgEnB3O8EcwN+GDAhmPu5YG5vyGOmBSSmIvIO+tsUH+6AeeC+QN575dwKZiVsCXdX/yIeDMJ8YwB3Blx31FNQtGB2L9gW/xXQ7Kin4GgHZrAn/hfggLNuAqUbs3shbfFngCMO+wiavcBL0n3s6BpwRJoxuxeSjBEWgWvoMz8R7ZgF9ChGzANjBPBR04f1gHrJY9aPTwNHMQs5q7enTwNvgRfAI3SQpSiKoiiKoiiK4owuYAiYQmapc6NR+VS5pi6LfYuTA0aAX8iLXi1WgGHkdgJaI4fZ4SAtcL3xjIyZMIK8qFHjjhUlUmQP0F/H73Vhbm1pQaPGClDcFlkWO+SBU8AJzHmBHv4tHdaasb0ENNkrzRpNwEWp6egmjNj9mFMqx4FqF0OtGj8Ah9MrzSlTrhP2AreBr9R/q9aiFOFv+RZOdobvA65i3ucTp8haSIuYNKzRgbnaf1ouUFpA7wwoAA9Ib0BUC2kBvTGgFbiB2YngskBpAb0woBf4KFSgtADS+TlH8ue8GhCTyykUoAbE5ALwO4UC1IAYFHH3hhMvBUgrf9wjSqPIvOFEwczfuLjy9Q6owvnkNSsV4kxHn0y9ClnSuAtiE2c6uoTb87W1ahQVMClxDHDdcKYN8OGgdkOjBgijBgijBgijBgijBgijBgijBgijBggT0kHtauhIWImPGiCMGiBMFgwI+Tsj57JgwKx0AQmYyYIBT6QLSMBj6QLSoEi4R5RCPVjyH8PICxo1hqwoIUQOc/RTWtR64ymw3YoSguQwRz99fhwtY678zIm/miJwC/N9xD6cHyuVa7nJBs/8v7IDIobYPn+VAAAAAElFTkSuQmCC"
}));

function SvgUserManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManage);
export default __webpack_public_path__ + "static/media/user-manage.88b639af.svg";
export { ForwardRef as ReactComponent };